export default __webpack_public_path__ + "static/media/target.b3688a90.svg";